import { render } from "./UploadProof.vue?vue&type=template&id=39f208b1&scoped=true"
import script from "./UploadProof.vue?vue&type=script&lang=js"
export * from "./UploadProof.vue?vue&type=script&lang=js"

import "./UploadProof.vue?vue&type=style&index=0&id=39f208b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f208b1"]])

export default __exports__